<template>
  <modal @close="$emit('close')" width="445px" height="auto" dark_theme class="modal-slider">
    <div class="wrapper_model-request overflow-h posr px-9 py-10" slot="body">
      <!-- лоадер -->
      <preloader v-if="loading"></preloader>

      <h4 class="h5New mb-3 mb-md-6">Откликнуться</h4>
      <div class="wrapper_model-request-message">
        Ждем Ваше резюме и краткий рассказ о себе на
        <a
          href="mailto:mail@bimlib.pro?subject=Отклик на вакансию bimlib"
          style="color: #00afa1"
        >mail@bimlib.pro</a>
      </div>
      <form
        @submit.prevent="validateBeforeSubmit(formScope)"
        @keydown.enter.prevent
        :data-vv-scope="formScope"
      >
        <!-- Имя -->
        <div class="posr mb-6">
          <bim-input
            type="text"
            id="name"
            name="name"
            v-model.lazy="input.name"
            data-vv-as="«Имя»"
            :error="errors.has('name', formScope)"
            v-validate="'required'"
            autofocus
            v-tooltip="{
              content: errors.first('name', formScope),
              show: errors.has('name', formScope),
              trigger: 'manual',
            }"
            placeholder="Имя*"
          ></bim-input>
        </div>

        <!-- Эл. почта -->
        <div class="posr mb-6">
          <bim-input
            type="email"
            id="email"
            name="email"
            dadataType="email"
            v-model.lazy="input.email"
            data-vv-as="«Электронная почта»"
            :error="errors.has('email', formScope)"
            v-validate="'required|email'"
            @focusedInput="getFocusEmail"
            v-tooltip="{
              content: errors.first('email', formScope),
              show: errors.has('email', formScope)
                    && !errors.has('name', formScope),
              trigger: 'manual',
            }"
            placeholder="Электронная почта*"
          ></bim-input>
        </div>

        <!-- Телефон -->
        <div class="posr mb-6">
          <bim-input
            mask="phone"
            type="tel"
            id="phone"
            name="phone"
            v-model.lazy="input.phone"
            data-vv-as="«Телефон»"
            :error="errors.has('phone', formScope)"
            v-validate="'required'"
            v-tooltip="{
              content: errors.first('phone', formScope),
              show: errors.has('phone', formScope)
                    && !errors.has('email', formScope)
                    && !errors.has('name', formScope),
              trigger: 'manual',
            }"
            placeholder="Телефон"
          ></bim-input>
        </div>

        <!-- Ссылка -->
        <div class="posr mb-6">
          <bim-input
            id="link"
            name="link"
            v-model.lazy="input.link"
            data-vv-as="«Ссылка на резюме»"
            :error="errors.has('link', formScope)"
            v-validate="'required'"
            v-tooltip="{
              content: errors.first('link', formScope),
              show: errors.has('link', formScope)
                    && !errors.has('phone', formScope)
                    && !errors.has('email', formScope)
                    && !errors.has('name', formScope),
              trigger: 'manual',
            }"
            placeholder="Ссылка на резюме или портфолио*"
          ></bim-input>
        </div>

        <!-- :class="[{'error-texarea': errors.has('message', formScope)}]" -->
        <div class="posr">
          <bim-textarea
            type="textarea"
            width="100%"
            class="mb-10 w-100"
            :error="errors.has('message', formScope)"
            name="message"
            id="commentVacancy"
            :placeholder="$t('Текст сообщения')"
            v-model.lazy="input.message"
            @keypress.enter.prevent
          />
        </div>

        <div class="button-block flex-wrap fz18">
          <v-btn color="green" big class="modal_btn order-md-1" type="submit" tabindex="1">Отправить</v-btn>
          <v-btn
            @click.prevent="$emit('close')"
            color="gray"
            outline
            big
            class="modal_btn main-color order-md-0 mt-md-0 mt-6"
            tabindex="2"
          >Отменить</v-btn>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
// Модалка
import bimInput from "@bimlib/components/bimInput"
import bimTextarea from "@bimlib/components/bimTextarea"
import modal from "@/athoms/Modal";
export default {
  components: {
    modal,
    bimInput,
    bimTextarea,
  },
  data() {
    return {
      input: {
        name: "",
        email: "",
        phone: "",
        link: "",
        message: ""
      },
      validPhone: true,
      formScope: "",
      loading: false,
      focusedEmail: false
    };
  },
  props: {
    vacancy_select: {
      type: String,
      required: true
    }
  },
  methods: {
    getFocusEmail(val) {
      this.focusedEmail = val;
    },
    closeModal() {
      this.input.name = "";
      this.input.email = "";
      this.input.phone = "";
      this.input.link = "";
      this.input.message = "";
      // this.$nextTick(() => {
      this.$emit("close");
      // })
    },
    validateBeforeSubmit(scope) {
      this.$store.dispatch("validationPhone", this.input.phone);
      this.validPhone = this.$store.getters.isValid;
      if (this.validPhone === true || this.input.phone === "") {
        this.$validator
          .validateAll(scope)
          .then(result => {
            if (result) {
              this.loading = true;
              const data = new FormData();
              if (!_.isEmpty(this.input.message)) {
                data.append("textmessage", this.input.message);
              }
              if (!_.isEmpty(this.input.email)) {
                data.append("email", this.input.email);
              }
              if (!_.isEmpty(this.input.phone)) {
                data.append("phone", this.input.phone);
              }
              if (!_.isEmpty(this.input.name)) {
                data.append("name", this.input.name);
              }
              if (!_.isEmpty(this.input.link)) {
                data.append("link", this.input.link);
              }
              if (!_.isEmpty(this.vacancy_select)) {
                if(this.vacancy_select === 'bk') {
                  data.append("vacancy_type", 'Специалист ОВиК / ВК (BIM)');
                }
                if(this.vacancy_select === 'javaDev') {
                  data.append("vacancy_type", 'Программист Java(Middle');
                }
                if(this.vacancy_select === 'analyst') {
                  data.append("vacancy_type", 'Аналитик/технический писатель');
                }
                if(this.vacancy_select === 'sales') {
                  data.append("vacancy_type", 'Менеджер по продажам услуг');
                }
              }
              axios
                .post("/mansendmsg/vacancy/", data)
                .then(response => {
                  // console.log(response);
                  if (response.data.success === true) {
                    this.loading = false;
                    this.closeModal();
                    this.$noty.success(
                      `<h5>Заявка принята</h5><span>Спасибо, мы свяжемся с вами в ближайшее время!</span>`,
                      {
                        killer: true,
                        timeout: this.$store.getters.getTimeoutNoty,
                        layout: "topRight",
                        progressBar: false
                      }
                    );
                  } else if (response.data.success === false) {
                    this.loading = false;
                    this.$noty.error(
                      `<h5>Ошибка</h5><span>Ой, что-то пошло не так, пожалуйста попробуйте снова</span>`,
                      {
                        killer: true,
                        timeout: this.$store.getters.getTimeoutNoty,
                        layout: "topRight"
                      }
                    );
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
            }
          })
          .catch(e => {
            console.log(e);
          });
      }
    }
  }
};
</script>


<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.loader {
  position: absolute;
  border-radius: 5px;
}
.button-block {
  display: flex;
  justify-content: space-between;
  .modal_btn {
    min-width: auto !important;
    flex: 0 0 calc(50% - 7px);
    @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
      min-width: 100% !important;
    }
  }
}
.wrapper_model-request {
  form {
    @media (min-height: 0) and (max-height: 560px) {
      display: none;
    }
  }
}
.wrapper_model-request-message {
  display: none;
  @media (min-height: 0) and (max-height: 560px) {
    display: block;
  }
}
</style>
